// extracted by mini-css-extract-plugin
module.exports = {"hero":"SostenibilitaDetailTemplate_hero__w8voc","rotation":"SostenibilitaDetailTemplate_rotation__pO2Pw"};